<div class="ai-document-cards" *transloco="let t; prefix: 'ai-assistant'">
  @if (title()) {
    <div class="ai-document-cards__title">{{ title() }}</div>
  }
  @if (hasDocuments()) {
    <div class="ai-document-cards__list">
      @for (doc of documents(); track $index) {
        <div class="ai-document-cards__card" (click)="toggleExpand($index)">
          <div class="ai-document-cards__card-header">
            @if (doc.sentiment) {
              <span class="ai-document-cards__sentiment" [class]="sentimentClass(doc)">
                {{ doc.sentiment }}
              </span>
            }
            @if (doc.entities?.length) {
              <span class="ai-document-cards__entities">
                @for (entity of doc.entities; track entity) {
                  <span class="ai-document-cards__entity">{{ entity }}</span>
                }
              </span>
            }
          </div>
          <div class="ai-document-cards__text">
            {{ isExpanded($index) ? doc.text : truncatedText(doc.text) }}
          </div>
          @if (doc.text.length > 150) {
            <button
              type="button"
              class="ai-document-cards__expand-btn"
              (click)="toggleExpand($index); $event.stopPropagation()"
            >
              {{ isExpanded($index) ? t('documents-show-less') : t('documents-show-more') }}
            </button>
          }
        </div>
      }
    </div>
    @if (hasMore()) {
      <div class="ai-document-cards__footer">
        {{
          t('documents-showing-count', {
            visible: documents().length,
            total: totalMatched(),
          })
        }}
      </div>
    }
  }
</div>
